import * as yup from 'yup';

export const validationSchema = () => {
  const schema = yup.object({
    name: yup.string("Enter a name").required("Name is required"),
  })
  return schema
}
